var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.125C0 0.503681 0.50368 0 1.125 0H6.58929C7.21061 0 7.71429 0.50368 7.71429 1.125V5.30357C7.71429 5.92489 7.21061 6.42857 6.58929 6.42857H1.125C0.503679 6.42857 0 5.92489 0 5.30357V1.125ZM1.4625 4.96607V1.4625H6.25179V4.96607H1.4625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2856 12.6964C10.2856 12.0751 10.7893 11.5714 11.4106 11.5714H16.8749C17.4963 11.5714 17.9999 12.0751 17.9999 12.6964V16.875C17.9999 17.4963 17.4963 18 16.8749 18H11.4106C10.7893 18 10.2856 17.4963 10.2856 16.875V12.6964ZM11.7481 16.5375V13.0339H16.5374V16.5375H11.7481Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.125 7.71429C0.50368 7.71429 0 8.21797 0 8.83929V16.875C0 17.4963 0.503679 18 1.125 18H6.58929C7.21061 18 7.71429 17.4963 7.71429 16.875V8.83929C7.71429 8.21797 7.21061 7.71429 6.58929 7.71429H1.125ZM1.4625 9.17679V16.5375H6.25179V9.17679H1.4625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2856 1.125C10.2856 0.50368 10.7893 0 11.4106 0H16.8749C17.4963 0 17.9999 0.50368 17.9999 1.125V9.16071C17.9999 9.78203 17.4963 10.2857 16.8749 10.2857H11.4106C10.7893 10.2857 10.2856 9.78203 10.2856 9.16071V1.125ZM11.7481 8.82321V1.4625H16.5374V8.82321H11.7481Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.87e546882f874608655976197c2a2d67.svg";
export { ForwardRef as ReactComponent };